import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {
  consultaTelefone,
  limpaProspectoEncaminhar,
} from '~/Store/Prospecto/actions';
import PropTypes from 'prop-types';
import ModalProspectoExistente from './ModalProspectoExistente';

class ConsultaTelefone extends Component {
  static propTypes = {
    values: PropTypes.object.isRequired,
    ignore: PropTypes.bool,
  };

  handleChange = event => {
    const { ignore, onChangeTelefone, consultaTelefone } = this.props;
    if (ignore) {
      onChangeTelefone(event);
      return;
    }
    const apenasNumeros = (event.target.value || '').replace(/\D/g, '');
    if (apenasNumeros.length === 11) {
      consultaTelefone(apenasNumeros);
    }
    onChangeTelefone(event);
  };

  encaminhaProspecto = () => {
    const {
      limpaProspectoEncaminhar,
      history,
      prospectoParaEncaminhar,
    } = this.props;
    const { codigo } = prospectoParaEncaminhar || {};
    limpaProspectoEncaminhar();
    if (codigo) {
      history.push(`/prospectos/${codigo}/dados-clientes/pessoais`);
    }
  };

  render() {
    const {
      onChangeTelefone,
      prospectoParaEncaminhar,
      consultandoTelefone,
      limpaProspectoEncaminhar,
    } = this.props;
    return (
      <>
        <ModalProspectoExistente
          show={prospectoParaEncaminhar && prospectoParaEncaminhar.codigo}
          onCancel={() => {
            limpaProspectoEncaminhar();
            onChangeTelefone('');
          }}
          prospectoParaEncaminhar={prospectoParaEncaminhar}
          onRedirect={this.encaminhaProspecto}
          label="telefone"
        />
        {this.props.children({
          onChangeTelefone: this.handleChange,
          consultandoTelefone: consultandoTelefone,
        })}
      </>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ consultaTelefone, limpaProspectoEncaminhar }, dispatch);

const mapStateToProps = state => ({
  consultandoTelefone: state.prospecto.consultandoTelefone,
  prospectoParaEncaminhar: state.prospecto.prospectoParaEncaminhar,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ConsultaTelefone)
);
